module.exports = __webpack_public_path__ + "static/media/natal.289bf6c3.svg";